export enum ValueType {
    CLASS = 'CLASS',
    FUNCTION = 'FUNCTION',
    VALUE = 'VALUE',
    VARIABLE = 'VARIABLE',
}
